var debug = function (value, value2) {
    if (value2) {
        console.log(value, value2);
    } else {
        console.log(value);
    }
}
export default debug;